export default function() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/call.js
// module id = ./node_modules/d3-selection/src/selection/call.js
// module chunks = vendor